// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { ConnectAddonProps } from './ConnectAddon.tsx';

export const ConnectAddon: LoadableType<ConnectAddonProps> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectAddon" */ './ConnectAddon.tsx'))
			.ConnectAddon,
	name: 'ConnectAddonNext',
});

export type { ConnectAddonDescriptor } from './ConnectAddon.tsx';
